import { render } from "./Spoed2.vue?vue&type=template&id=6f2ab66c&scoped=true"
import script from "./Spoed2.vue?vue&type=script&lang=js"
export * from "./Spoed2.vue?vue&type=script&lang=js"

import "./Spoed2.vue?vue&type=style&index=0&id=6f2ab66c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f2ab66c"]])

export default __exports__